import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./Audience.module.css";

export function Audience() {
  const { audience } = useMaestriaContent();

  return (
    <section
      id="publico"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="audience-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <div className={styles.divider} aria-hidden="true" />
        <div className={styles.row}>
          <h2 id="audience-title" className={styles.title}>
            {audience.titleLine1 ?? "Para quem é"}
            <br />
            <strong>{audience.titleLine2 ?? "este programa?"}</strong>
          </h2>
          <ul className={styles.grid}>
            {audience.cards.map((card) => (
              <li key={card.title} className={styles.card}>
                <img src={card.image} alt={card.imageAlt} width={288} height={252} loading="lazy" />
                <div className={styles.body}>
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
